module.exports = __webpack_public_path__ + "static/media/deck-c-straight.e43b4594.png";